import { render } from "./PolicyChildPage.vue?vue&type=template&id=dbc122a2&scoped=true"
import script from "./PolicyChildPage.vue?vue&type=script&lang=js"
export * from "./PolicyChildPage.vue?vue&type=script&lang=js"

import "./policyChildDoc.css?vue&type=style&index=0&lang=css"
import "./PolicyChildPage.vue?vue&type=style&index=1&id=dbc122a2&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc122a2"]])

export default __exports__